<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image2" /> -->
    <transition appear
                @before-enter="$animations.beforeEnterLogoArea"
                @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>

    <transition appear
                @before-enter="$animations.beforeEnterAbove"
                @enter="$animations.enterAbove"
    >
      <div class="columns mb-0 is-centered">
        <div v-if="$root.selectedLanguage === `en`" class="column" style="text-align: center">
          <img
            src="../assets/images/icons/RBDSecondheaderImagesEng/Group 289354.png"
            alt="document.png"
            width="70%"
          />
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <img
            src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37575.png"
            alt="document.png"
            width="70%"
          />
        </div>
      </div>
    </transition>

    <transition appear
                @before-enter="$animations.beforeEnterAbove"
                @enter="$animations.enterAbove"
    >
      <div class="columns is-centered">
        <div class="column is-half ps-5" style="text-align: center">
          <img
            src="../assets/images/icons/Blue/Group 161.png"
            alt="document.img"
            width="70"
            height="70"
          />
          <p :class="`text-center mx-3 ${
              $root.selectedLanguage === `ta`
                ? `ta-he-line`
                : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
            }`"
             style="font-family: OpenSans-Bold; ">
            {{ $root.selectedLanguageData.documents }}
          </p>
          <p :class="`text-center mx-3 ${
              $root.selectedLanguage === `ta`
                ? `ta-sub-line`
                : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
            }`"
             style="font-family: OpenSans-Bold; ">
            {{ $root.selectedLanguageData.uploadtheseimagestoverify }}
          </p>
          <p style="font-family: OpenSans-Regular; ">
            {{ $root.selectedLanguageData.dataEditByButton }}
          </p>
        </div>
      </div>
    </transition>
    <ValidationObserver>
      <form @submit.prevent="onSubmit">
        <div class="columns is-centered">
          <div class="column is-half pt-5 ps-5">
            <div>
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`" 
                    >{{ $root.selectedLanguageData.uploadimagesofpassport }}
                    <span class="has-text-danger">*</span></label
                  >
              
              <p style="font-family: OpenSans-Regular; font-size: 18px">
                {{
                  $root.selectedLanguageData
                    .noteUploadthefrontpageofyourpassportMakesurethereisnoblurorglare
                }}
              </p>
              <b-field
                :class="{ 'has-name': !!$root.productImages.passport_image }"
              >
                <ValidationProvider
                  :rules="{ required: true, size: 1024, image: true }"
                  name="image"
                  v-slot="{ errors }"
                >
                  <image-capture-component  class="imageCaptureComponent"   @on-captured="onPassportCaptured" :crop_ratio=16/10 file_name="passport_image" :selectedImageURL="$root.imageurl.passportimageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>

                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>

            <!-- selfieimage -->
            <div class="mt-5">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`" 
                    >{{ $root.selectedLanguageData.uploadyourselfieimage}}
                    <span class="has-text-danger">*</span></label
                  >
              <p style="font-family: OpenSans-Regular; font-size: 18px">
                {{
                  $root.selectedLanguageData
                    .noteUploadtheclearimageofyourselfMakesurethereisnoblurorglare
                }}
              </p>

              <b-field
                :class="{ 'has-name': !!$root.productImages.selfie_image }"
              >
                <ValidationProvider
                  :rules="{ required: true, size: 1024, image: true }"
                  name="image"
                  v-slot="{ errors }"
                >
                  <image-capture-component class="imageCaptureComponent" @on-captured="onSelfieCaptured" :crop_ratio=1/1 file_name="selfie_image" :selectedImageURL="$root.imageurl.selfie_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
            <!-- signatureimage -->
            <div class="mt-5">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`" 
                    >{{ $root.selectedLanguageData.uploadyoursignatureimage}}
                    <span class="has-text-danger">*</span></label
                  >
             
              <p style="font-family: OpenSans-Regular; font-size: 18px">
                {{
                  $root.selectedLanguageData
                    .notepleasesignyoursignatureonawhitepaperandthentakeanimageofit
                }}
              </p>
              <b-field
                :class="{ 'has-name': !!$root.productImages.sign_image }"
              >
                <ValidationProvider
                  :rules="{ required: true, size: 1024, image: true }"
                  name="image"
                  v-slot="{ errors }"
                >
                  <image-capture-component class="imageCaptureComponent" @on-captured="onSignatureCaptured" :crop_ratio=7/4 file_name="sign_image" :selectedImageURL="$root.imageurl.signature_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
            <!-- Visa Proof of the Country Residing -->
            <div
              class="mt-5"
              v-if="$root.formData.residentship === `Non Resident`"
            > <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`" 
                    >{{ $root.selectedLanguageData.visa_proof_of_the_country_residing}}
                    </label
                  >
             
              <p style="font-family: OpenSans-Regular; font-size: 18px">
                {{
                  $root.selectedLanguageData
                    .take_a_picture_from_your_device_or_upload_an_already_available_picture
                }}
              </p>
              <b-field
                :class="{
                  'has-name': !!$root.productImages.visa_proof_doc,
                }"
              >
                <ValidationProvider
                  :rules="{  size: 1024, image: true }"
                  name="image"
                  v-slot="{ errors }"
                >

                  <image-capture-component  class="imageCaptureComponent" @on-captured="onVisaProofCaptured" :crop_ratio=9/13 file_name="visa_proof_doc" :selectedImageURL="$root.imageurl.visa_proof_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>

            <!-- proofofaddress_images -->
            <div class="mt-5">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`" 
                    >{{ $root.selectedLanguageData.uploadyourproofofaddress}}
                    </label
                  >
              

              <p
                style="font-family: OpenSans-Regular; font-size: 18px; line-height: 24px"
              >
                {{
                  $root.selectedLanguageData
                    .notePleaseaddaphotoofanElectricityWaterorTelephonebillthatclearlyshowsyournameandresidentialaddress
                }}
              </p>
              <b-field
                :class="{
                  'has-name': !!$root.productImages.addr_proof_doc,
                }"
              >
                <ValidationProvider
                  :rules="{ required: true, size: 1024, image: true }"
                  name="image"
                  v-slot="{ errors }"
                >
                  <image-capture-component  class="imageCaptureComponent" @on-captured="onAddressProofCaptured" :crop_ratio=16/9 file_name="addr_proof_doc" :selectedImageURL="$root.imageurl.address_proof_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
          </div>
        </div>

        <transition appear
                    @before-enter="$animations.beforeEnterBelow"
                    @enter="$animations.enterBelow"
        >
          <div class="columns mb-3">
            <div
              class="column is-6 is-offset-3 is-flex is-flex-direction-row-reverse"
            >
              <b-button
                :class="`is-primary  ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"
                :loading="isContinueButtonLoading"
                :disabled="!$root.productImages.passport_image || !$root.productImages.selfie_image || !$root.productImages.sign_image "
                @click="navigateToNextPage()"
                >{{ $root.selectedLanguageData.continue }}</b-button
              >
              <b-button  :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`" @click="$router.go(-1)">{{
                $root.selectedLanguageData.back
              }}</b-button>
            </div>
          </div>
        </transition>
      </form>
    </ValidationObserver>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>
<script>
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
import imageCaptureComponent from "@/components/supports/ImageCaptureComponent";

export default {

  data(){
    return {
      isContinueButtonLoading: false,
      passportFaceIdReceived : false,
      selfieFaceIdReceived : false,

      // these two variables are used to check if the faces are detected in the images
      passportFaceNotDetected : false,
      selfieFaceNotDetected : false,

     
    }
  },
  components: {
    GetHelp,
    Logo,
    imageCaptureComponent,
  },
  watch: {
    "$root.productImages.passport_image": function () {
      if (this.$root.productImages.passport_image) {
        this.$root.imageurl.passportimageurl = URL.createObjectURL(
          this.$root.productImages.passport_image
        );
      }
    },
    "$root.productImages.selfie_image": function () {
      if (this.$root.productImages.selfie_image) {
        this.$root.imageurl.selfie_imageurl = URL.createObjectURL(
          this.$root.productImages.selfie_image
        );
      }
    },
    "$root.productImages.sign_image": function () {
      if (this.$root.productImages.sign_image) {
        this.$root.imageurl.signature_imageurl = URL.createObjectURL(
          this.$root.productImages.sign_image
        );
      }
    },
    "$root.productImages.addr_proof_doc": function () {
      if (this.$root.productImages.addr_proof_doc) {
        this.$root.imageurl.address_proof_imageurl = URL.createObjectURL(
          this.$root.productImages.addr_proof_doc
        );
      }
    },
    "$root.productImages.visa_proof_doc": function () {
      if (this.$root.productImages.visa_proof_doc) {
        this.$root.imageurl.visa_proof_imageurl = URL.createObjectURL(
          this.$root.productImages.visa_proof_doc
        );
      }
    },
  },

  methods: {
    onNicCaptured: function (e){
      // alert(e)
      this.$root.productImages.nic_front_image = e
      console.log("NIC front image : "+this.$root.productImages.nic_front_image)
    },

    onNicBackCaptured: function (e){
      this.$root.productImages.nic_back_image = e
      console.log("NIC back image : "+this.$root.productImages.nic_back_image)
    },

    onSelfieCaptured: function (e){
      this.$root.productImages.selfie_image = e
      console.log("Selfie image : "+this.$root.productImages.selfie_image)
    },

    onSignatureCaptured: function (e){
      this.$root.productImages.sign_image = e
      console.log("Signature image : "+this.$root.productImages.sign_image)
    },

    onAddressProofCaptured: function (e){
      this.$root.productImages.addr_proof_doc = e
      console.log("Address proof image : "+this.$root.productImages.addr_proof_doc)
    },

    onPassportCaptured: function (e){
      this.$root.productImages.passport_image = e
      console.log("Passport image : "+this.$root.productImages.passport_image)
    },

    onVisaProofCaptured: function (e){
      this.$root.productImages.visa_proof_doc = e
      console.log("Visa proof image : "+this.$root.productImages.visa_proof_doc)
    },

    /**
     * A method to navigate to the next page --------------------------
     */
    navigateToNextPage() {
      const comp = this;

      // get face id details
      comp.getFaceIdDetails(comp.$root.productImages.passport_image, "passport");
      comp.getFaceIdDetails(comp.$root.productImages.selfie_image, "selfie");

      comp.checkFaceIdsReceived()
    },

    /**
     * This method is used to verify is the face id details are received --------------------------
     */
    checkFaceIdsReceived(){
      const comp = this

      if(!comp.passportFaceIdReceived || !comp.selfieFaceIdReceived ){

        comp.isContinueButtonLoading = true
        setTimeout(this.checkFaceIdsReceived,100)
      }
      else{
        // TODO :: handle face not detected validation
        if(!comp.passportFaceNotDetected && !comp.selfieFaceNotDetected){ // enable to continue if face is detected in nic front and selfie images
          this.$router.push("previewpage");
        }
        // this.$router.push("previewpage");
        comp.isContinueButtonLoading = false
        comp.passportFaceIdReceived = false
        comp.selfieFaceIdReceived = false
      }
    },

    /**
     *  A method to get face id details from images --------------------
     */
    async getFaceIdDetails(image, imageType) {
      const comp = this;
      var bodyFormData = new FormData();

      bodyFormData.append("image_file", image);
      // bodyFormData.append("kyc_token", this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12);
      let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        comp.$http
        .post(this.$baseURL + "/kycForm/identifyFace", bodyFormData, {
          headers: { "Content-Type": "multipart/form-data","X-token":kyc_token },
        })
        .then(function (response) {
          if (response.data.length > 0) {
            console.log("Recieved face id details --------------------");
            console.log(response);

            var tmpFaceId = response.data[0].faceId;

            console.log("-----------------------------------------");
            console.log(
              "Image type : " +
                imageType +
                " Image : " +
                image +
                " Face ID value : " +
                tmpFaceId
            );

            if (imageType === "nic" || imageType === "passport") {
              // if passed image is a NIC or Passport image
              comp.$root.formData.face_ids.nic = tmpFaceId;
              comp.passportFaceNotDetected = false
            } else {
              // if passed image is selfie image
              comp.$root.formData.face_ids.selfie = tmpFaceId;
              comp.selfieFaceNotDetected = false
            }



          } else {
            console.log("face not detected");

            // TODO :: complete face not detected validation

            let message = ''

            if(imageType === 'selfie'){
              message = 'No face detected in selfie image!'
              comp.selfieFaceNotDetected = true
            }
            else {
              message = 'No face detected in the passport image!'
              comp.passportFaceNotDetected = true
            }

            comp.$buefy.toast.open({
              message: message+" Select another image",
              type: "is-danger",
            });
          }

          // enable each variable after face details received
          imageType === 'passport' ?  comp.passportFaceIdReceived = true : comp.selfieFaceIdReceived = true
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
    },



    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
        this.$http
          .post(this.$baseURL + "/kycForm/updateLastStep", {
            last_step_name:'Value Added Services',
            last_step: 6,
            form_filled:true,
            next_route:'Employment Info',
          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },
  },
  mounted: function () {
    this.updateLastStep();

    // initialize variables
    this.passportFaceIdReceived = false
    this.selfieFaceIdReceived = false
    this.isContinueButtonLoading = false
    this.passportFaceNotDetected = false
    this.selfieFaceNotDetected = false
  },
};
</script>
<style scoped>

</style>
